"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class EvaluationQuestionAnswer {
  static thaw(evaluationQuestionAnswerObj) {
    if (evaluationQuestionAnswerObj == null) return null;
    const evaluationQuestionAnswer = new EvaluationQuestionAnswer();
    if (evaluationQuestionAnswerObj.id != null) evaluationQuestionAnswer.setId(evaluationQuestionAnswerObj.id);
    if (evaluationQuestionAnswerObj.checkboxValue != null) evaluationQuestionAnswer.setCheckboxValue(evaluationQuestionAnswerObj.checkboxValue == null ? null : evaluationQuestionAnswerObj.checkboxValue ? true : false);
    if (evaluationQuestionAnswerObj.notes != null) evaluationQuestionAnswer.setNotes(evaluationQuestionAnswerObj.notes);
    if (evaluationQuestionAnswerObj.isResolved != null) evaluationQuestionAnswer.setIsResolved(evaluationQuestionAnswerObj.isResolved == null ? null : evaluationQuestionAnswerObj.isResolved ? true : false);
    if (evaluationQuestionAnswerObj.isNotApplicable != null) evaluationQuestionAnswer.setIsNotApplicable(evaluationQuestionAnswerObj.isNotApplicable == null ? null : evaluationQuestionAnswerObj.isNotApplicable ? true : false);
    if (evaluationQuestionAnswerObj.questionId != null) evaluationQuestionAnswer.setQuestionId(evaluationQuestionAnswerObj.questionId);
    if (evaluationQuestionAnswerObj.evaluationId != null) evaluationQuestionAnswer.setEvaluationId(evaluationQuestionAnswerObj.evaluationId);
    if (evaluationQuestionAnswerObj.evaluationSectionAnswerId != null) evaluationQuestionAnswer.setEvaluationSectionAnswerId(evaluationQuestionAnswerObj.evaluationSectionAnswerId);
    if (evaluationQuestionAnswerObj.question != null) evaluationQuestionAnswer.setQuestion(_.EvaluationQuestion.thaw(evaluationQuestionAnswerObj.question));
    if (evaluationQuestionAnswerObj.remedyChoices != null) evaluationQuestionAnswer.setRemedyChoices(_.EvaluationRemedyChoice.thawList(evaluationQuestionAnswerObj.remedyChoices));
    if (evaluationQuestionAnswerObj.evaluation != null) evaluationQuestionAnswer.setEvaluation(_.Evaluation.thaw(evaluationQuestionAnswerObj.evaluation));
    return evaluationQuestionAnswer;
  }

  static thawList(evaluationQuestionAnswerObjList) {
    if (evaluationQuestionAnswerObjList == null) return [];
    var evaluationQuestionAnswers = [];

    for (var i = 0; i < evaluationQuestionAnswerObjList.length; i++) {
      evaluationQuestionAnswers.push(EvaluationQuestionAnswer.thaw(evaluationQuestionAnswerObjList[i]));
    }

    return evaluationQuestionAnswers;
  }

  static freeze(evaluationQuestionAnswer) {
    if (evaluationQuestionAnswer == null) return null;
    var evaluationQuestionAnswerObj = {};
    if (evaluationQuestionAnswer.getId() != null) evaluationQuestionAnswerObj.id = evaluationQuestionAnswer.getId();
    if (evaluationQuestionAnswer.getCheckboxValue() != null) evaluationQuestionAnswerObj.checkboxValue = evaluationQuestionAnswer.getCheckboxValue() == null ? null : evaluationQuestionAnswer.getCheckboxValue() ? 1 : 0;
    if (evaluationQuestionAnswer.getNotes() != null) evaluationQuestionAnswerObj.notes = evaluationQuestionAnswer.getNotes();
    if (evaluationQuestionAnswer.getIsResolved() != null) evaluationQuestionAnswerObj.isResolved = evaluationQuestionAnswer.getIsResolved() == null ? null : evaluationQuestionAnswer.getIsResolved() ? 1 : 0;
    if (evaluationQuestionAnswer.getIsNotApplicable() != null) evaluationQuestionAnswerObj.isNotApplicable = evaluationQuestionAnswer.getIsNotApplicable() == null ? null : evaluationQuestionAnswer.getIsNotApplicable() ? 1 : 0;
    if (evaluationQuestionAnswer.getQuestionId() != null) evaluationQuestionAnswerObj.questionId = evaluationQuestionAnswer.getQuestionId();
    if (evaluationQuestionAnswer.getEvaluationId() != null) evaluationQuestionAnswerObj.evaluationId = evaluationQuestionAnswer.getEvaluationId();
    if (evaluationQuestionAnswer.getEvaluationSectionAnswerId() != null) evaluationQuestionAnswerObj.evaluationSectionAnswerId = evaluationQuestionAnswer.getEvaluationSectionAnswerId();
    if (evaluationQuestionAnswer.getQuestion() != null) evaluationQuestionAnswerObj.question = _.EvaluationQuestion.freeze(evaluationQuestionAnswer.getQuestion());
    if (evaluationQuestionAnswer.getRemedyChoices() != null) evaluationQuestionAnswerObj.remedyChoices = _.EvaluationRemedyChoice.freezeList(evaluationQuestionAnswer.getRemedyChoices());
    if (evaluationQuestionAnswer.getEvaluation() != null) evaluationQuestionAnswerObj.evaluation = _.Evaluation.freeze(evaluationQuestionAnswer.getEvaluation());
    return evaluationQuestionAnswerObj;
  }

  static freezeList(evaluationQuestionAnswers) {
    if (evaluationQuestionAnswers == null) return [];
    var evaluationQuestionAnswerObjList = [];

    for (var i = 0; i < evaluationQuestionAnswers.length; i++) {
      evaluationQuestionAnswerObjList.push(EvaluationQuestionAnswer.freeze(evaluationQuestionAnswers[i]));
    }

    return evaluationQuestionAnswerObjList;
  }

  constructor() {
    this.setId(null);
    this.setCheckboxValue(null);
    this.setNotes(null);
    this.setIsResolved(null);
    this.setIsNotApplicable(null);
    this.setQuestionId(null);
    this.setEvaluationSectionAnswerId(null);
    this.setEvaluationId(null);
    this.setQuestion(null);
    this.setRemedyChoices(null);
    this.setEvaluation(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setCheckboxValue(checkboxValue) {
    this.checkboxValue = checkboxValue;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  setIsResolved(isResolved) {
    this.isResolved = isResolved;
  }

  setIsNotApplicable(isNotApplicable) {
    this.isNotApplicable = isNotApplicable;
  }

  setQuestionId(questionId) {
    this.questionId = questionId;
  }

  setEvaluationId(evaluationId) {
    this.evaluationId = evaluationId;
  }

  setEvaluationSectionAnswerId(evaluationSectionAnswerId) {
    this.evaluationSectionAnswerId = evaluationSectionAnswerId;
  }

  setQuestion(question) {
    this.question = question;
  }

  setRemedyChoices(remedyChoices) {
    this.remedyChoices = remedyChoices;
  }

  setEvaluation(evaluation) {
    this.evaluation = evaluation;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getCheckboxValue() {
    return this.checkboxValue;
  }

  getNotes() {
    return this.notes;
  }

  getIsResolved() {
    return this.isResolved;
  }

  getIsNotApplicable() {
    return this.isNotApplicable;
  }

  getQuestionId() {
    return this.questionId;
  }

  getEvaluationId() {
    return this.evaluationId;
  }

  getEvaluationSectionAnswerId() {
    return this.evaluationSectionAnswerId;
  }

  getQuestion() {
    return this.question;
  }

  getRemedyChoices() {
    return this.remedyChoices;
  }

  getEvaluation() {
    return this.evaluation;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  isConditionalQuestion() {
    return this.remedyChoices == null || this.remedyChoices.length === 0;
  }

  hasSelectedRemedyChoice() {
    var _this$remedyChoices;

    let isChoiceSelected = false;
    (_this$remedyChoices = this.remedyChoices) === null || _this$remedyChoices === void 0 ? void 0 : _this$remedyChoices.forEach(remedyChoice => {
      if (remedyChoice.isSelected) isChoiceSelected = true;
    });
    return isChoiceSelected;
  }

  hasProvidedRecommendations() {
    return this.hasSelectedRemedyChoice() || this.notes != null && this.notes !== '';
  }

}

exports.default = EvaluationQuestionAnswer;